import React from 'react';
import PropTypes from 'prop-types';
import "./rscard.css"
import CurrencyFormat from 'react-currency-format';

const RsCardImgv2 = ({ title, description, iconClass, userdetail }) => {
  return (
  <div className="card rs-card bg-v2 rs-card-compact">
  <div className="card-body py-2 px-3">
    <div className="d-flex align-items-center justify-content-between">
      
      <div className="lead-number">
        <h2 className="mb-0 fw-bold text-dark">

         {title === "Performance / Goals" ? (
                <CurrencyFormat
                  value={description}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={userdetail?.agentDefaultCurrencyCode + " " }
                />
              ) : (
                description
              )}
       
        </h2>
      </div>
     
      <div className="text-end d-flex flex-column align-items-center">
        { iconClass ? <img src={iconClass} width={36} alt="icon" className="mb-1" /> : '' }
        <h6 className="mb-0 text-muted font-size-18">{title}</h6>
      </div>

    </div>
  </div>
</div>

  );
};

RsCardImgv2.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  iconClass: PropTypes.string,
  userdetail: PropTypes.object,
};

RsCardImgv2.defaultProps = {
  title: 'Default Title',
  description: 'Default Description',
  iconClass: 'bx-default-icon',
};

export default RsCardImgv2;